import React, { useState, useEffect, useRef } from "react";
import { IonItem, IonLabel, IonSelect, IonSelectOption } from "@ionic/react";
import "./DropdownComponent.scss";
import _ from "lodash";
import { t } from "i18next";
import { useTranslation } from "react-i18next";


/**
 * Drop down component
 * Component will show a drop down to select from list.
 * Component will return the selectd item id.
 */
interface ListModal {
  dataId: number;
  dataName: string;
}

interface DropDownItemProps {
  siteListData: ListModal[];
  getSelectedItem: (value: number,key?:any) => void;
  enableMultipleSelection?: boolean;
  favCardData?: any;
  isFromTeams?: boolean;
  selectedSiteData?: any;
  value?: any;
  dropDownValue?: any;
  selectedValue?:any;
  componentName?:string;
}

const DropDown: React.FC<DropDownItemProps> = (props) => {
  var [hospitalId, setHospitalId]: any = useState(Number);
  const userInteractedRef = useRef(false);
    const { t } = useTranslation("onCallLookup");

  // clearing the hospitalId if the component is OCL and the selectedValue is not present
  useEffect(()=>{
    if(props.componentName === "OCL"){
      setHospitalId(props.selectedValue ? hospitalId : 0);
    }
  },[props.selectedValue])

  useEffect(() => {
    setFavCardSite();
    if (props.isFromTeams) {
      setSelectedSite();
    }
  }, [props.siteListData]);

  const setSelectedSite = () => {
    props.getSelectedItem(props.selectedSiteData);
    setHospitalId(props.selectedSiteData);
  };

  const setFavCardSite = () => {
    if (!_.isEmpty(props.favCardData)) {
      // props.getSelectedItem(Number(props.favCardData.params.hospital_id));
      setHospitalId(Number(props.favCardData.params.hospital_id));
    }
  };

const getValue = () => {
  switch (props.dropDownValue) {
    case "Select age":
      return t("selectAge");
    case "Select ETA":
      return t("selectETA");
    case "Select Unit":
      return t("selectUnit");
    case "Select age unit":
      return t("selectAgeUnit");
    case "Select Network":
      return t("selectNetwork");
    default:
      return t("sites");
  }
};

  const getByPlaceholderText = () => {
  switch (props.dropDownValue) {
    case "Select age":
      return `-- ${t("selectAge")} --`;
    case "Select ETA":
      return `-- ${t("selectETA")} --`;
    case "Select unit":
      return `-- ${t("selectUnit")} --`;
    case "Select age unit":
      return `-- ${t("selectAgeUnit")} --`;
    case "Select Network":
      return `-- ${t("selectNetwork")} --`;
    default:
      return `-- ${t("selectSite")} --`;
  }
};

  return (
    <IonItem
      className={`site-dropdown ${props.isFromTeams ? "teams-site" : ""}`}
    >
      <IonSelect
        okText="Done"
        cancelText={t("cancel")}
        value={hospitalId}
        onIonChange={(e) => {
          if (!userInteractedRef.current) return;
          props.getSelectedItem(e.detail.value);
          setHospitalId(e.detail.value);
        }}
        // placeholder={"--Select--"}
        placeholder={getByPlaceholderText()}
        multiple={props.enableMultipleSelection ? true : false}
        onClick={() => (userInteractedRef.current = true)}
      >
        <IonLabel>{getValue()}</IonLabel>

        {props?.dropDownValue === "Select Network" ?
          props.siteListData.map((item) => (
            <IonSelectOption value={item.dataName} key={item.dataId}>
              {item.dataName}
            </IonSelectOption>
          )) :
          props.siteListData.map((item) => (
            <IonSelectOption value={item.dataId} key={item.dataId}>
              {item.dataName}
            </IonSelectOption>
          ))

        }

      </IonSelect>
    </IonItem>
  );
};

export default DropDown;
